import { ValidationResultTuple, QuestionValidators } from '~app/pages/SurveyTaking/validation/types';
import { safeValidatorExecution } from '~app/pages/SurveyTaking/validation/helpers/index';

export default (
  questionValidation: QuestionValidators,
  questionId: string,
  answerValue: string
): ValidationResultTuple => {
  return questionValidation.validators.reduce<ValidationResultTuple>(
    (questionValidationState, validator) => {
      const [answerIsValid, messages] = questionValidationState;
      const answerValidationResult = safeValidatorExecution(questionId, answerValue, validator, true);

      return [
        answerIsValid && answerValidationResult.isValid(),
        [...(messages ?? []), ...answerValidationResult.messages],
      ];
    },
    [true, []]
  );
};
